module App {
    function LineBreakFilter(): Function {
        return function (input:string) {
            return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
        };
    }

    angular.module("app").filter("lineBreak", LineBreakFilter);
}